import portfolioSvg from '../assets/portfolio.svg'
import ticTacToeSvg from '../assets/tic-tac-toe.svg'
import quizGameSvg from '../assets/quiz-game.svg'
import googleTrexCloneSvg from '../assets/google-trex-clone.svg'
import csharpTasksSvg from '../assets/csharp-tasks.svg'
import csharpTestsSvg from '../assets/csharp-tests.svg'
import githubTrafficSvg from '../assets/github-traffic.svg'
import githubTrafficBackendSvg from '../assets/github-traffic-backend.svg'

export interface Project {
  title: string
  description: string
  platform: string
  color: string
  link: string
  element: JSX.Element
}

export const projects: Project[] = [
  {
    title: 'Portfolio',
    description: 'Web Development • 2025',
    platform: 'React',
    color: 'bg-black',
    link: 'https://github.com/nikseell/portfolio-website',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={portfolioSvg}
          alt="Portfolio"
          className="w-60 h-60 md:w-96 md:h-96"
        />
      </div>
    ),
  },
  {
    title: 'GitHub Traffic Frontend',
    description: 'Web Development • 2025',
    platform: 'React',
    color: 'bg-gray-200',
    link: 'https://github.com/nikseell/github-traffic-frontend',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={githubTrafficSvg}
          alt="GitHub Traffic"
          className="w-60 h-60 md:w-96 md:h-96"
        />
      </div>
    ),
  },
  {
    title: 'GitHub Traffic Backend',
    description: 'Backend Development • 2025',
    platform: 'NestJS',
    color: 'bg-black',
    link: 'https://github.com/nikseell/github-traffic-backend',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={githubTrafficBackendSvg}
          alt="GitHub Traffic Backend"
          className="w-60 h-60 md:w-96 md:h-96"
        />
      </div>
    ),
  },
  {
    title: 'Tic Tac Toe',
    description: 'Game Development • 2023',
    platform: 'Unity',
    color: 'bg-gray-200',
    link: 'https://github.com/nikseell/tic-tac-toe',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={ticTacToeSvg}
          alt="Tic Tac Toe"
          className="w-60 h-60 md:w-96 md:h-96"
        />
      </div>
    ),
  },
  {
    title: 'Google Trex Clone',
    description: 'Game Development • 2023',
    platform: 'Unity',
    color: 'bg-gray-100',
    link: 'https://github.com/nikseell/google-trex-clone',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={googleTrexCloneSvg}
          alt="Google Trex Clone"
          className="w-60 h-60 md:w-96 md:h-96 opacity-90"
        />
      </div>
    ),
  },
  {
    title: 'Quiz Game',
    description: 'Game Development • 2020',
    platform: 'Unity',
    color: 'bg-black',
    link: 'https://balvurcb.lv/spele/',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={quizGameSvg}
          alt="Quiz Game"
          className="w-60 h-60 md:w-96 md:h-96 opacity-90"
        />
      </div>
    ),
  },
  {
    title: 'C# Tasks',
    description: 'Backend Development • 2021',
    platform: 'C#, .NET',
    color: 'bg-gray-200',
    link: 'https://github.com/nikseell/c-sharp',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={csharpTasksSvg}
          alt="C# Tasks"
          className="w-60 h-60 md:w-96 md:h-96"
        />
      </div>
    ),
  },
  {
    title: 'C# Tests',
    description: 'Testing • 2021',
    platform: 'C#, .NET',
    color: 'bg-gray-100',
    link: 'https://github.com/nikseell/c-sharp-tests',
    element: (
      <div className="w-full h-full flex items-center justify-center">
        <img
          src={csharpTestsSvg}
          alt="C# Tests"
          className="w-60 h-60 md:w-96 md:h-96"
        />
      </div>
    ),
  },
]
